import { CheckboxMultipleMarkedOutlineIcon } from './CheckboxMultipleMarkedOutlineIcon';

/**
 * author: Austin Andrews
 * id 16BECBE7-BD8E-4301-B5CB-5EE534FBDAD3
 * name checkbox-multiple-marked-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-multiple-marked-outline.svg
 * tags
 * - Form 
 */
export const CheckboxesMarkedOutlineIcon = CheckboxMultipleMarkedOutlineIcon;
export default CheckboxesMarkedOutlineIcon